import { render } from "./MyFooter.vue?vue&type=template&id=6ab8fe7a&scoped=true"
import script from "./MyFooter.vue?vue&type=script&lang=js"
export * from "./MyFooter.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6ab8fe7a"

export default script